import { LINK_HOME } from '../links';

export const BOOKED = 'Booked';
export const CLICK_REDEEM_IT = "Click 'Redeem it!'";
export const READY_TO_REDEEM = 'Ready to redeem';
export const NOW = 'Now';
export const SAVE = 'Save';
export const FREE = 'FREE';
export const FROM = 'From';
export const OPTIONS = 'options';
export const SOLD_OUT = 'SOLD OUT';
export const GENERIC_FAILURE = 'Something went wrong. Please try again.';
export const ERROR_MESSAGE =
  "We couldn't contact the payment provider right now. Please pay using Visa or Mastercard.";
export const LIABILITY_ERROR = `Unfortunately, your payment did not go through. Please try again or select a different payment method`;
export const NO_EXPRESS_BUY =
  'Requested deal cannot be purchased via Express Buy.';
export const TRY_DIFFERENT = ' Sorry please try a different payment method.';
export const GENERIC_ERROR =
  'An error occured, your purchase has not been completed.';
export const PROGRESS_MESSAGE_WAIT = 'Please wait...';
export const PROGRESS_MESSAGE_PAY = 'Making payment...';
export const PROGRESS_MESSAGE_SUCCESS = 'Purchase Successful';
export const PROGRESS_MESSAGE_FAILED = 'Payment failed.';
export const USER_DOESNT_EXISTS =
  'You have not yet registered with us. Please register to continue.';

export const DEALS_PROMO_TYPES = (newProductionLink = '') => {
  return {
    buyAgain: {
      link: `${LINK_HOME}/buy-again`,
      linkName: 'View all',
      title: 'Buy again',
    },
    earlyBird: {
      link: `${LINK_HOME}/early-bird`,
      linkName: 'View all',
      title: 'Early Bird Deals',
    },
    newProducts: {
      link: `${LINK_HOME}${newProductionLink}`,
      linkName: 'View all',
      title: 'New Products',
    },
    recentlyViewed: {
      link: `${LINK_HOME}/recently-viewed`,
      linkName: 'View all',
      title: 'Recently Viewed',
    },
    recommended: {
      link: `${LINK_HOME}/recommended-for-you`,
      linkName: 'View all',
      title: 'Recommended for you',
    },
  };
};
export const TRY_CHECKOUT = ' Please try our checkout service instead.';
export const SUBSCRIPTION_ERROR = `Error on user subscription.`;
export const AN_ERROR_OCCURED = 'An error occured';
export const FACETED_NAV_COMPONENT = {
  allCatPage: 'All ##word## deals',
  defaultSeoText: '',
  defaultSeoTextCategory:
    'Browse our ##CATEGORY## deals and offers and save up to 80%. Whether you’re spoiling yourself or treating someone else, you’re sure to find that perfect deal in our ##CATEGORY## sale.',
  defaultSeoTextSubcategory:
    'Browse our ##SUBCATEGORY## deals and offers and save up to 80%. Whether you’re spoiling yourself or treating someone else, you’re sure to find that perfect deal in our ##SUBCATEGORY## sale.',
  seoLocationText:
    'Save on ##LOCATION## attractions, restaurants and spa days with hundreds of deals on ##SITE_NAME##. We’ve got discounts on everything from day trips and experience days to afternoon teas and nights out in ##LOCATION## for you to browse!',
  siteName: '5pm',
  wellnessSeoText:
    'Browse our Spa deals and offers and save up to 80%. Whether you’re spoiling yourself or treating someone else, you’re sure to find that perfect deal in our Spa sale.',
  wellnessSeoTitle: 'Wellness',
};
export const VIP = 'VIP';

export const PASSWORD_SIX_CHARACTERS = 'Password must be at least 6 characters';
export const REGISTER_ENTER_VALID_EMAIL = 'Enter a valid email';
export const REGISTER_ENTER_VALID_POSTCODE = 'Enter a valid postcode';
export const REGISTER_POSTCODE_DOESNT_EXIST = `The postcode you entered doesn't exist. Please enter your address manually below`;
export const REGISTER_MATCH_PASSWORD = 'Passwords should match';
export const REQUIRED_FIELD = 'Required field';

export const SHARE_BY_EMAIL = 'Share by email';
export const SHARE_ON_FACEBOOK = 'Share on Facebook';
export const SHARE_ON_TWITTER = 'Share on Twitter';
export const SHARE_ON_WHATSAPP = 'Share on WhatsApp';
export const COPY = 'COPY';

export const INVALID_GOOGLE_TOKEN_ID = 'Invalid google token id';
export const SUBSCRIPTION_FAIL = `Email wasn't registered`;

export const HYPER_LOCAL_SEO_TITLE = (seoFriendlyName, area) =>
  `${seoFriendlyName} near ${area}`;

export const META_DESCRIPTION = {
  default:
    'Huge discounts on the latest and greatest products. Shop now and save up to 80% on hundreds of amazing deals.',
  'gift-finder': {
    default:
      "Save up to 80% on the latest and greatest gifts in ##LOCATION## and shopping. We've got massages, afternoon tea, toys, jewellery and loads more.",
    'national-deal':
      "Save up to 80% on the latest and greatest gifts in shopping. We've got perfumes, toys, jewellery and loads more.",
    travel: `Save up to 80% on the latest and greatest gifts in ##TRAVELESCAPE## and shopping. We've got spa breaks, city breaks, toys, jewellery and loads more.`,
  },
  local: {
    activity: `Looking for something fun to do in ##LOCATION##? From paintballing to bungee jumping and supercars to bubble football, you're sure to find an adrenaline fueled activity on 5pm. Save up to 80%.`,
    adult:
      "For adult eyes only! Browse adult products and naughty things to do in ##LOCATION##. Save up to 80%. Sex toys, enhancers and adult themed shows - don't miss out!",
    beauty: `Time for a pamper? You'll find the latest and greatest ##LOCATION## beauty treatments on 5pm . From haircuts to facials, we're always looking out for the next thing that'll make us feel fabulous.`,
    default: `Save up to 80% on deals in ##LOCATION## – From restaurants and beauty to entertainment and fitness, 5pm has hundreds of deals in your area.`,
    entertainment: `Concerts, Sporting events, Tarot Reading, Cinemas and more. Whether you're trying to impress someone or planning a weekend with friends, check out 5pm for great events in ##LOCATION##. Save up to 80%.`,
    'food-drink':
      "Save up to 80% on the best restaurants in ##LOCATION##. From fine dining to quick eats, we've got an ever-changing range of amazing food and drink deals for you. Bon appetit.",
    'health-fitness':
      "Find the best health and fitness deals that ##LOCATION## has to offer. If gym passes and bootcamps don't do it for you, shop our amazing fitness products. Save up to 80%.",
    kids: "From toys and games to learning aids, we're sure to have something to keep the little ones occupied. Keep an eye out for exciting things for the kids to do in ##LOCATION##. Save up to 80%.",
    learning:
      "We're always looking for that next thing to add to our CV. From interior design to Excel training, we've got a wide range of vocational and recreational online and ##LOCATION## classroom based courses. Save up to 80%.",
    travel: `Save up to 80% on ##TRAVELESCAPE## deals – From short breaks in the UK and relaxing spa breaks to beach holidays and long haul adventures, 5pm has hundreds of cheap ##TRAVELESCAPE## deals.`,
  },
  shop: {
    default:
      'Huge discounts on the latest and greatest products. Shop now and save up to 80% on hundreds of amazing deals.',
    electricals:
      'Save up to 80% on cheap electronics and accessories. Computers, laptops, android tablets, in-car accessories and more.',
    'fashion-jewellery':
      "Save up to 80% on the latest fashion trends. Jewellery, watches, fashion and accessories - we've got hundreds of products to make you look fabulous. Happy shopping!",
    'home-essentials':
      'Save up to 80% on household essentials. Toilet rolls, toothbrush heads, dish-washing tablets and more.',
    'home-garden':
      "Home sweet home! Save up to 80% on furniture, art, bedding, mattresses, garden accessories and more. We've got hundreds of deals to help you get the home of your dreams.",
  },
  'special-event': {
    default: `Save up to 80% on ##EVENTNAME## deals in ##LOCATION##. From restaurants and beauty to entertainment and fitness, 5pm  has hundreds of deals in your area.`,
  },
  travel: {
    adventure: `Looking for something a bit different from your holiday? Tours, animals, adventures and the magical Disneyland are but a few options from 5pm . Book now and save up to 50%.`,
    beach: `Feel sand between your toes with a 5pm  beach break. Short-haul including flights, and offers for further afield. Book your summer holiday now.`,
    'city-breaks':
      "Enjoy a weekend away in a choice of amazing European cities. Including flights, hotel only or all-inclusive, there's a deal here for you. Save up to 50%.",
    default: `Save up to 80% on ##TRAVELESCAPE## deals – From short breaks in the UK and relaxing spa breaks to beach holidays and long haul adventures, 5pm has hundreds of cheap ##TRAVELESCAPE##  deals.`,
    family:
      "Holiday fun for all the family! Whether it's Disneyland or a beach holiday, we've got something that'll keep you all entertained. Save up to 50%.",
    'last-minute': `Need a break now? Last minute breaks from 5pm  have discounts of up to 50% for stays starting this weekend! Book now.`,
    romantic:
      "Treat a loved one to a romantic break and save up to 50%. With deals for 2 people, including flights and accommodation, there's a hassle-free weekend away waiting for you!",
    'spa-and-health': `Relax, pamper yourself and save up to 50% while you're doing it. UK and European spa breaks starting from just ##CURRENCY_SYMBOL##59. Ahhhh.`,
    'sports-and-activities': `Get-up-and-go holidays from 5pm . Save up to 50% on a holiday you won't forget. Sailing, Skiing, Hiking and Kayaking and just a few ideas to get you started.`,
    'uk-city-breaks':
      "Enjoy a weekend away in the UK. From a relaxing countryside break to the hustle and bustle of the city, there's plenty to choose from. Save up to 50%.",
  },
};
export const TITLE_DEALS_LOCATION = '##CATEGORY## - ##LOCATION## - ';
export const TITLE_DEALS_NO_LOCATION = '##CATEGORY## - ';
export const TITLE_DEALS_NO_CATEGORY =
  '##LOCATION## Deals - Up to 80% off Vouchers & Offers - ';
export const TITLE_DEALS_NO_CATEGORY_NOLOCATION =
  'Shop - Online Deals & Vouchers of up to 80% off - ';
export const TITLE_ESCAPES_NO_CATEGORY_NOLOCATION =
  'Escapes - Online Deals & Vouchers of up to 80% off - ';
export const TITLE_VIP_HUB = `Exclusive Deals, VIP Offers & Discounts - Up to 80% Off -`;

export const TTILE_WELLNESS_DEALS = 'Wellness Collection deals | ';

// Payment
export const SAVED_CARD = `savedCard`;
// Payment Errors
export const ERROR_BANK_UNRESPONSIVE = `We tried to take payment but didn’t get a response from your Bank. Try a different card or use Paypal and then try again.`;
export const ERROR_BILLING_ADDRESS = `Oops, it looks like you’ve typed your billing address incorrectly. Please try again!`;
export const ERROR_CARD_AMEX_DINERS = `We don’t accept American Express / Diners Card so try again using another card type, or use Paypal!`;
export const ERROR_CARD_DECLINED = `Sorry, your card has been declined. Please try another card or payment method.`;
export const ERROR_CARD_DECLINED_BANK = `Sorry, your card has been declined by your bank. Please try another card or payment method.`;
export const ERROR_CARD_DECLINED_DETAILS = `Sorry, your card has been declined. Please check that you entered the details correctly or try another card/payment method.`;
export const ERROR_CARD_EXPIRED = `Oh no, this card has expired! Add a new card or why not try PayPal!`;
export const ERROR_CARD_EXPIRED_NEW_CARD = `Oh no, this card has expired! Add a new card and let’s get this payment sorted.`;
export const ERROR_CARD_INCORRECT_ADDRESS = `Oops, it looks like you’ve typed your address incorrectly. Please try again!`;
export const ERROR_CARD_INCORRECT_CVV = `Oops, it looks like you’ve typed your CVV incorrectly. Please try again!`;
export const ERROR_CARD_INCORRECT_DATE = `Oops, it looks like you’ve typed your expiry date incorrectly. Please try again!`;
export const ERROR_CARD_INCORRECT_NUMBER = `Oops, it looks like you’ve typed your card number incorrectly. Please try again!`;
export const ERROR_CARD_INCORRECT_SECURITY_CODE = `Oops, it looks like you’ve typed your security code incorrectly. Please try again!`;
export const ERROR_ISSUER_AUTHENTICATION =
  'Your card issuer cannot authenticate this card. Please select another card or form of payment to complete your purchase.';
export const ERROR_PAYPAL_REJECTION = `Sorry, PayPal rejected that transaction. Please check your account or try an alternative payment method.`;
export const PAYPAL_OR_SWITCH = `paypalOrSwitch`;
export const POPULATE_CARD_INPUT = `cardInputPop`;
export const POPULATE_CARD_OR_SWITCH = `popOrSwitch`;
export const POPULATE_EMPTY_CARD_OR_SWITCH = `popEmptyOrSwitch`;

export const PREFORMATTED_STRING = {
  brandTerminology: {
    brand: '5pm',
    wowcher_or_voucher: 'voucher',
    Wowcher_or_voucher: 'voucher',
    wowchers_or_vouchers: 'vouchers',
    Wowchers_or_vouchers: 'vouchers',
  },
};
